module.exports = __webpack_public_path__ + "img/payment_complated.a4ee0357.png";